<template>
  <customer-engagement />
</template>

<script>
import CustomerEngagement from "@/components/3pl/CRM/CustomerEngagement/CustomerEngagement";
export default {
  components: {
    CustomerEngagement,
  },
};
</script>

<style></style>
